package com.anjuros.website.templates.template9.sections

import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.anjuros.website.templates.template9.components.Template9Reveal
import androidx.compose.runtime.Composable
import com.anjuros.website.templates.template9.components.Template9SectionTitle
import com.anjuros.website.templates.template9.components.Template9ServiceCard
import com.anjuros.website.templates.template9.components.Template9Sparks
import com.anjuros.website.templates.template9.modules.Template9Section
import com.anjuros.website.templates.template9.modules.Template9Service
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.modules.getColorHex
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9SectionPaddingStyle
import com.anjuros.website.templates.template9.util.ResKey
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun Template9ServiceSection() {
    Column(
        modifier = Template9SectionPaddingStyle.toModifier()
            .id(Template9Section.Services.id)
            .fillMaxWidth()
            .backgroundColor(Template9Theme.Background.rgb),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = Template9ContainerStyle.toModifier(),
            contentAlignment = Alignment.TopCenter
        ) {
            Template9Sparks(
                modifier = Modifier
                    .displayIfAtLeast(Breakpoint.MD)
                    .align(Alignment.TopStart)
                    .margin(top = 10.px),
                color = Template9Theme.Primary.getColorHex()
            )
            Template9Sparks(
                modifier = Modifier
                    .displayIfAtLeast(Breakpoint.MD)
                    .align(Alignment.TopEnd)
                    .margin(top = 10.px),
                color = Template9Theme.Primary.getColorHex()
            )
            Template9Reveal(contentAlignment = Alignment.TopCenter) {
                Template9SectionTitle(
                    eyebrow = ResKey.TEMPLATE9_SERVICES_EYEBROW,
                    title = ResKey.TEMPLATE9_SERVICES_TITLE
                )
            }
        }

        SimpleGrid(
            numColumns = numColumns(base = 1, md = 2, lg = 4),
            modifier = Template9ContainerStyle.toModifier()
                .margin(top = 40.px)
                .gap(24.px)
        ) {
            Template9Service.entries.forEach { service ->
                Template9Reveal(
                    modifier = Modifier.fillMaxWidth().fillMaxHeight(),
                    delayMs = service.ordinal * 120
                ) {
                    Template9ServiceCard(service)
                }
            }
        }
    }
}
